import { render, staticRenderFns } from "./App.vue?vue&type=template&id=acf64f5e&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=acf64f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf64f5e",
  null
  
)

export default component.exports